<template>
  <div>
    <div class="container">
      <el-page-header class="page-header" @back="goBack" content="我的地址"></el-page-header>
      <div class="contact-header">
        <el-button class="button-add" round type="danger" @click="showAddDialog = true" size="mini">添加地址</el-button>
        <el-input class="input-circle" v-model="searchText" placeholder="收件人姓名或手机号码"  clearable></el-input>
        <el-button class="button-search" round type="primary" @click="getAddressList" size="mini">搜 索</el-button>
      </div>
      <el-table
        :data="addressList"
        border
        style="width: 100%;margin-top: 20px;margin-bottom: 20px;">
        <el-table-column
          fixed
          prop="receiverName"
          label="姓名"
          width="110">
        </el-table-column>
        <el-table-column
          fixed
          prop="addressInfoText"
          label="省市区"
          width="260">
        </el-table-column>
        <el-table-column
          fixed
          prop="street"
          label="详细地址"
          width="340">
        </el-table-column>
        <el-table-column
          fixed
          prop="phoneNo"
          label="电话"
          width="120">
        </el-table-column>
        <el-table-column
          fixed
          prop="zipCode"
          label="邮编"
          width="100">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="180">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="deleteAddress(scope.row)">删除</el-button>
            <el-button type="text" size="medium" @click="editAddress(scope.row)">编辑</el-button>
            <el-button type="text" size="medium" v-if="isSelect" @click="selectAddress(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="totalPage > 10" style="margin-top: 20px;" background layout="prev, pager, next" :current-page="currentPageNo"
        @current-change="pageChange" :total="totalPage">
      </el-pagination>
      <div class="empty-container" v-if="addressList.length == 0">
        <span>{{emptyText}}</span>
      </div>
    </div>
    <el-dialog :title="isEdit?'编辑地址' : '添加地址'" :visible.sync="showAddDialog" center destroy-on-close width="750px">
      <div style="display: flex;flex-direction: column;">
        <el-form label-width="120px" label-position="right" class="basic-info" :model="deliveryFormData">
          <el-form-item label="*姓名：" class="form-item">
              <el-input v-model="deliveryFormData.receiverName" ref="nameId" type="text" placeholder="请输入收件人姓名" clearable></el-input>
          </el-form-item>
          <el-form-item label="*联系电话：" class="form-item">
              <el-input v-model="deliveryFormData.phoneNo" ref="phoneId" type="number" placeholder="请输入联系人手机号码" clearable></el-input>
          </el-form-item>
          <el-form-item label="*省市区：" class="form-item">
              <el-cascader
              style="width: 100%;"
              placeholder="请选择或搜索地址"
              size="medium"
              :filterable="true"
              @change="addressChange"
              v-model="deliveryFormData.addressInfo"
              :options="areaOptions"></el-cascader>
              <span v-show="addressTemp&&addressTemp.length>0" style="text-align: start;width: 300px; position: absolute;color: #606266;background-color: white;left: 10px;line-height: 14px;">{{addressTemp}}</span>
          </el-form-item>
          <el-form-item label="*详细地址：" class="form-item">
              <el-input v-model="deliveryFormData.street" type="textarea" ref="customAddressId" placeholder="请输入详细地址(街道门牌信息)" clearable></el-input>
          </el-form-item>
          <el-form-item label="邮政编码：" class="form-item">
              <el-input v-model="deliveryFormData.zipCode" type="number" placeholder="请输入邮政编码" clearable></el-input>
          </el-form-item>
        </el-form>
        <div style="width: 500px; display: flex;flex-direction: row;margin-left: 140px;">
          <el-button type="primary" style="width: 180px;" size="medium" @click="saveAddress">保 存</el-button>
          <el-button type="default" style="width: 180px;" size="medium" @click="dismiss">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  import AreaHeader from '@/components/widgets/area-header.vue'
  import store from '../../store'
  import { EventBus } from "../../js/eventbus.js"
  export default {
    components:{
        AreaHeader,
    },
    data () {
      return {
        addressList:[],
        deliveryFormData:{
          city: "",
          county: "",
          phoneNo: "",
          province: "",
          receiverName: "",
          street: "",
          zipCode:'',
          addressInfo:[],
          addressInfoText:[],
        },
        showAddDialog:false,
        searchText:'',
        addressTemp:'',
        currentPageNo: 1,
        pageSize:12,
        totalPage: 1,
        emptyText: '您还没有地址',
        isEdit:false,
        isSelect:false,
        area: {}
      }
    },
    computed: {
        areaOptions() {
            var area = this.$store.state.areaInfo;
            if(!area || !Array.isArray(area.province_list)) return [];
            
            var provinces = [];
            var citiesMap = {}; 
            var countiesMap = {}; 
            
            // 1. Prepare Counties
            if(area.county_list){
                area.county_list.forEach(county => {
                    var cCode = county.parentAreaCode;
                    if(!countiesMap[cCode]) countiesMap[cCode] = [];
                    countiesMap[cCode].push({
                        value: county.areaCode,
                        label: county.name
                    });
                });
            }
            
            // 2. Prepare Cities
            if(area.city_list){
                area.city_list.forEach(city => {
                    var pCode = city.parentAreaCode;
                    if(!citiesMap[pCode]) citiesMap[pCode] = [];
                    
                    var cityNode = {
                        value: city.areaCode,
                        label: city.name
                    };
                    if(countiesMap[city.areaCode] && countiesMap[city.areaCode].length > 0) {
                        cityNode.children = countiesMap[city.areaCode];
                    }
                    citiesMap[pCode].push(cityNode);
                });
            }
            
            // 3. Prepare Provinces
            if(area.province_list){
                area.province_list.forEach(province => {
                    var pCode = province.areaCode;
                    var provinceNode = {
                        value: pCode,
                        label: province.name
                    };
                    if(citiesMap[pCode] && citiesMap[pCode].length > 0) {
                        provinceNode.children = citiesMap[pCode];
                    }
                    provinces.push(provinceNode);
                });
            }
            
            return provinces;
        }
    },
    created() {
      var mode = this.$route.query.mode
      this.isSelect = mode == 1
      this.getAddressList()
    },
    mounted() {
        this.area = this.$store.state.areaInfo
    },
    methods:{
      goBack(){
          this.$router.go(-1)
      },
      getAddressList(){
        this.wjtHttp.get(this,'/api/delivery/address/list',{
                  pageNum:this.currentPageNo,
                  pageSize:this.pageSize,
                  keyWord:this.searchText
                },true,(res)=>{
                var data = res.data
                if(data.code == 200){
                  if(!this.utils.isEmptyStr(data.rows)) {
                    this.totalPage = Math.ceil(data.total / 12) * 10
                  } else if(this.currentPageNo == 1) {
                    this.totalPage = 1
                  }
                  for(var i=0;i<data.rows.length;i++){
                    var item = data.rows[i]
                    item.addressInfo = [item.province,item.city,item.county]
                    item.addressInfoText = item.province+'/'+item.city+'/'+item.county
                  }
                  this.addressList = data.rows
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'获取地址列表异常',
                        type:'error'
                    })
                }
            },(err)=>{
                console.log(err)
            })
      },
      dismiss(){
        this.showAddDialog = false
        this.cancelEdit()
      },
      getName(list, code){
            if(!list || !Array.isArray(list)) return '';
            let item = list.find(x => x.areaCode == code);
            return item ? item.name : '';
        },
        addressChange(e){
            console.log(e)
            if(e.length >= 2) {
                this.deliveryFormData.province = this.getName(this.area.province_list, e[0])
                this.deliveryFormData.city = this.getName(this.area.city_list, e[1])
                if(e.length >= 3){
                    this.deliveryFormData.county = this.getName(this.area.county_list, e[2])
                } else {
                    this.deliveryFormData.county = ''
                }
                this.addressTemp = ''
            }
        },
      editAddress(item){
        console.log(item)
        this.deliveryFormData = {
          receiverName:item.receiverName,
          phoneNo:item.phoneNo,
          province:item.province,
          city:item.city,
          county:item.county,
          street:item.street,
          zipCode:item.zipCode,
          addressInfo:[item.province,item.city,item.county],
          addressInfoText:item.province+'/'+item.city+'/'+item.county,
          deliveryAddressId:item.deliveryAddressId
        }
        this.isEdit =  true
        this.showAddDialog =  true
        this.addressTemp = this.deliveryFormData.addressInfoText
      },
      deleteAddress(item){
        this.$confirm('确定删除该地址信息吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.wjtHttp.delete(this,'/api/delivery/address/'+item.deliveryAddressId,{},true,(res)=>{
                  var data = res.data
                  if(data.code == 200){
                    this.$message({
                      type: 'success',
                      message: '删除成功!'
                    });
                    this.getAddressList()
                  }else{
                      this.$message({
                          message:(data.msg&&data.msg.length > 0)?data.msg:'删除地址列表异常',
                          type:'error'
                      })
                  }
              },(err)=>{
                  console.log(err)
              })
        }).catch(() => {

        });

      },
      saveAddress(){
        if(this.deliveryFormData.receiverName.length == 0){
          this.$nextTick(() => {
            this.$refs.nameId.focus();
          })
          this.$message("请输入收件人姓名")
          return
        }
        if(this.deliveryFormData.phoneNo.length != 11){
          this.$nextTick(() => {
            this.$refs.phoneId.focus();
          })
          this.$message("请输入正确的11位手机号")
          return
        }
        if(this.deliveryFormData.addressInfo.length == 0){
          this.$message("请选择省市区")
          return
        }
        if(this.deliveryFormData.street.length == 0){
          this.$nextTick(() => {
            this.$refs.customAddress.focus();
          })
          this.$message("请输入详细地址")
          return
        }
        console.log(this.deliveryFormData)
        this.wjtHttp.post(this,this.isEdit?'/api/delivery/address/edit':'/api/delivery/address/add',this.deliveryFormData,true,(res)=>{
                var data = res.data
                if(data.code == 200){
                  this.clearAddress()
                  this.getAddressList()
                  this.showAddDialog = false
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:(this.isEdit?"编辑地址异常":'获取地址列表异常'),
                        type:'error'
                    })
                }
            },(err)=>{
                console.log(err)
            })
      },
      cancelEdit(){
        this.isEdit = false
        this.clearAddress()
        this.addressTemp = ""
      },
      clearAddress(){
        this.deliveryFormData = {
          city: "",
          county: "",
          phoneNo: "",
          province: "",
          receiverName: "",
          street: "",
          zipCode:'',
          addressInfo:[],
          addressInfoText:'',
          deliveryAddressId:""
        }
        this.addressTemp = ""
      },
      selectAddress(item){
        sessionStorage.setItem('selectAddress',JSON.stringify(item))
        this.$router.go(-1)
      },
      pageChange(pageNo) {
        this.currentPageNo = pageNo
        this.getAddressList()
      },
    },
    watch:{
      searchText:function(val){
          if(this.utils.isEmptyStr(val)){
            this.currentPageNo = 1
            this.getAddressList()
          }
      },
      showAddDialog:function(val){
        if(!val){
          this.cancelEdit()
        }
      }
    }
  }
</script>

<style scoped>
  .container{
      width: 1160px;
      margin: auto auto;
  }
  .page-header{
      width: 1080px;
      margin-top: 30px;
      color: #333333;
      font-size: 20px;
  }
  .page-header >>> div{
      color:#333333;
      font-size: 20px;
  }
  .area-header-one{
      margin-top: 35px;
  }
  .contact-header {
    padding: 8px 10px;
    background: #F9F9F9;
    height: auto;
    width: 1160px;
    text-align: right;
    margin-top: 20px;
  }
  .input-circle{
    width: 360px;
    height: 32px;
    margin-bottom: 8px;
    margin-right: 20px;
    float: left;
  }
  .button-search{
    height: 42px;
    width: 100px;
    float: left;
  }
  .button-add{
    height: 42px;
    width: 180px;
  }
  .form--item-colomn{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .form-item{
    width: 65%;
  }
  .basic-info{
    width: 985px;
    margin-top: 30px;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/address.vue